import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./context/authContext";
import { useOptions } from "./context/optionContext";

const SpecialProtectedRoute = () => {
	const { isAuthenticated, user, sendOtp } = useAuth();
	const location = useLocation();
	const [otpSent, setOtpSent] = useState(false);
	const { mfaDays, mfaEnabled } = useOptions();
	// const handleSendOTP = async () => {
	// 	if (needsEmailVerification && !otpSent) {
	// 		await sendOtp(user.user_id);
	// 		setOtpSent(true);
	// 	}
	// };

	// If not authenticated at all, redirect to login
	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}
	if (isAuthenticated && !user.eula_accepted) {
		console.log("User Need to Accept EULA:", !user.eula_accepted);
		return <Navigate to="/accept-eula" replace />;
	}

	if (
		isAuthenticated &&
		mfaEnabled &&
		(!user.email_verified ||
			(user.email_verified_date &&
				new Date() - new Date(user.email_verified_date) > mfaDays * 24 * 60 * 60 * 1000))
	) {
		console.log("User Need Email Verification:", user.email_verified);
		console.log("MFA Days: ", mfaDays);
		console.log("Days from last verified: ", new Date() - new Date(user.email_verified_date));
		console.log(
			"Check: ",
			user.email_verified_date && new Date() - new Date(user.email_verified_date) > mfaDays * 24 * 60 * 60 * 1000
		);
		return <Navigate to="/verify-email" replace />;
	} else {
		console.log("MFA Enabaled", mfaEnabled);
		console.log("MFA Days", mfaDays);
	}

	return <Outlet />;
};

export default SpecialProtectedRoute;
